import { Service } from '@genial/services';
import { BeneficiariesRequest } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { BeneficiariesFormData } from '../../../pages/CustomerDetail/components/PrivatePensionContacted/components/ChangeBeneficiaries/constants';

export const customerDetailPrivatePensionActions = () => {
  const executePrivatePensionNewApplication = (
    value: number,
    insuranceProposalId: number,
    clientEmail: string,
    advisorEmail?: string
  ) => {
    return Service.Pension.V1.postGenerateBankSlip({
      screenName: 'privatePensionNewApplicationModal',
      pensionBankSlipRequest: {
        amount: value,
        insuranceProposalId,
        emails: { recipient: clientEmail, copy: advisorEmail },
      },
    });
  };

  const normalizeBeneficiariesToSend = (
    beneficiaries: BeneficiariesFormData['beneficiaries']
  ): BeneficiariesRequest[] => {
    return beneficiaries
      .filter((beneficiary) => beneficiary.birthDate !== null)
      .map((beneficiary) => ({
        beneficiaryName: beneficiary.name,
        relationshipId: parseInt(beneficiary.relationship, 10),
        birthDate: beneficiary.birthDate as Date,
        percentage: Utils.Unmask.Percentage(beneficiary.participation),
      }));
  };

  const updatePrivatePensionBeneficiaries = (
    certificateId: string,
    customerCpf: string,
    beneficiaries: BeneficiariesRequest[]
  ) => {
    return Service.Pension.V1.putBeneficiaryUpdate({
      screenName: 'changeBeneficiaries',
      updateBeneficiaryRequest: {
        beneficiaries,
        certificateId,
        customerCpf,
      },
    });
  };

  return {
    executePrivatePensionNewApplication,
    normalizeBeneficiariesToSend,
    updatePrivatePensionBeneficiaries,
  };
};
